import React from 'react';
import styled from '@mui/system/styled';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import theme from '../theme/theme';
import {useMediaQuery} from '@mui/material';

const AddButton = ({onClick, ...props}) => {
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <CustomButton
      onClick={onClick}
      {...props}
      size={isSmallScreen ? 'small' : 'medium'}>
      <AddIcon fontSize="inherit" />
    </CustomButton>
  );
};

const CustomButton = styled(IconButton)`
  background-color: ${theme.palette.primary.main};
  color: white;
  &:hover {
    background-color: ${theme.palette.primary.dark};
  }
`;

export default AddButton;
